"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VenueBreadcrumbReactionRequestDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const breadcrumb_reaction_constants_1 = require("../../constants/breadcrumb-reaction.constants");
class VenueBreadcrumbReactionRequestDto {}
exports.VenueBreadcrumbReactionRequestDto = VenueBreadcrumbReactionRequestDto;
__decorate([(0, swagger_1.ApiProperty)({
  maxLength: breadcrumb_reaction_constants_1.MAX_BREADCRUMB_REACTION_EMOJI_LENGTH
}), __metadata("design:type", String)], VenueBreadcrumbReactionRequestDto.prototype, "emoji", void 0);
//# sourceMappingURL=VenueBreadcrumbReactionRequest.dto.js.map